import api from '@/api/index.js'

const external_emv_taps = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_EXTERNAL_EMV_TAPS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_EXTERNAL_EMV_TAPS: (state, response) => {
      state.data = response
      state.loading = false
    },
    SET_EXTERNAL_EMV_TAPS_ERROR: (state, error) => {
      state.error = error
    },
    SET_EXTERNAL_EMV_TAPS_FILTER_DETAILS: (state, filterDetails) => {
      state.filterDetails = filterDetails
    }
  },

  actions: {
    LoadExternalEmvTaps({commit}, query) {
      commit('SET_EXTERNAL_EMV_TAPS', [])
      commit('SET_EXTERNAL_EMV_TAPS_ERROR', null)
      commit('SET_EXTERNAL_EMV_TAPS_LOADING', true)
      return api.get(`emv-external-taps?limit=500&offset=0`)
        .then((response) => {
          commit('SET_EXTERNAL_EMV_TAPS', response)
        })
        .catch((error) => {
          commit('SET_EXTERNAL_EMV_TAPS_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_EXTERNAL_EMV_TAPS_LOADING', false)
        })
    }
  }
}

export default external_emv_taps
